import { render, staticRenderFns } from "./StripeSuccess.vue?vue&type=template&id=5231075a&"
import script from "./StripeSuccess.vue?vue&type=script&lang=js&"
export * from "./StripeSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports